import { STUDIO_HERO_IMAGE } from '@/common/constants/studioPublicMedia';

export const HERO_IMAGE = STUDIO_HERO_IMAGE;

export const PLAN_MARKS = {
	BASIC: 'B',
	PRO: 'P',
	PREMIUM: '★',
};

export const PLAN_DURATION_KEYS = {
	BASIC: 'planDurationBasic',
	PRO: 'planDurationPro',
	PREMIUM: 'planDurationPremium',
};

export const PLAN_BENEFIT_KEYS = [
	'planPaywallBenefitUncensored',
	'planPaywallBenefitPrivatePhotos',
	'planPaywallBenefitPriorityAi',
];

export const PLAN_TIER_ORDER = ['PREMIUM', 'PRO', 'BASIC'];
